import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { useWorkspaceId } from '@app/hooks/useWorkspaceId';

import { fetchEmailStyle } from '../../state';

function FetchCustomEmailSetting() {
  const dispatch = useDispatch();
  const workspaceId = useWorkspaceId();

  useEffect(() => {
    // FIXME: 사가 사용하지 말고 react-query로 바꾸기
    if (workspaceId) {
      dispatch(fetchEmailStyle());
    }
  }, [dispatch, workspaceId]);

  return null;
}

export default FetchCustomEmailSetting;
